import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryTabs() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            热门<strong className="text-primary-500">分类</strong>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">探索你感兴趣的漫画类型</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-200 group-hover:bg-primary-100 flex items-center justify-center transition-colors">
                <i className={`text-xl md:text-2xl text-primary-500 ${
                  cat.slug === 'romance' ? 'ri-heart-line' :
                  cat.slug === 'fantasy' ? 'ri-magic-line' :
                  cat.slug === 'action' ? 'ri-sword-line' :
                  cat.slug === 'mystery' ? 'ri-search-eye-line' :
                  cat.slug === 'slice-of-life' ? 'ri-cup-line' :
                  cat.slug === 'bl' ? 'ri-moon-line' :
                  'ri-emotion-laugh-line'
                }`}></i>
              </div>
              <div className="text-center">
                <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.count}部</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}